module.exports = __webpack_public_path__ + "static/media/photo-12.a8eb960a.webp";